export default {
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            checked: false
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        if (this.index === 0) {
            this.checked = true;
        }
    },
    methods: {
        /**
         * Scroll to clicked domain.
         */
        scrollToElement() {
            const domain = this.$refs.row;

            if (domain) {
                domain.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }
};
